import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  orgNotificationSettings,
  saveOrgNotificationSettings,
  type TNotificationChannel,
  type TOrgMatrixPatch,
} from '../../entities/notification';

const KEY = ['notification-settings', 'organization'];

export const useNotificationRules = () => {
  const client = useQueryClient();

  const settings = useQuery({ queryKey: KEY, queryFn: orgNotificationSettings });

  const save = useMutation({
    mutationFn: (patch: TOrgMatrixPatch) => saveOrgNotificationSettings(patch),
    onSuccess: (next) => client.setQueryData(KEY, next),
  });

  const toggle = (category: string, channel: TNotificationChannel, enabled: boolean) =>
    save.mutate({ [category]: { [channel]: enabled } });

  return { settings, save, toggle };
};

export type TNotificationRules = ReturnType<typeof useNotificationRules>;
